import {createSlice} from "@reduxjs/toolkit";

export const NAME = 'live-chart';

const initialState = {
    datetime: undefined,
    value: undefined,
    assetId: undefined,
    isActive: false,
}

const {actions, reducer} = createSlice({
    name: NAME,
    initialState,
    reducers: {
        setLiveChartHoverValues: (state, {payload}) => {
            const { value, datetime, assetId } = payload
            state.value = value
            state.datetime = datetime
            state.assetId = assetId
            state.isActive = true
        },
        setLiveChartHoverIsInactive: state => {
            state.isActive = false
        },
        reset: () => ({
            ...initialState
        }),
    }
})

export const {
    setLiveChartHoverValues,
    setLiveChartHoverIsInactive,
} = actions

const getState = state => state[NAME]

export const getAssetId = state => getState(state).assetId
export const getValue = state => getState(state).value
export const getDatetime = state => getState(state).datetime
export const getIsActive = state => getState(state).isActive


export const getLiveChartHoverValues = (state, assetId) => getAssetId(state) !== assetId ? [] : [getValue(state), getDatetime(state)]
export const getIsLiveChartActive = (state, assetId) => getAssetId(state) === assetId && getIsActive(state)

export default reducer